// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3bItC","buttons":"PendingPaymentAlert_buttons__bgLIu"};